module.exports = __webpack_public_path__ + "img/KV_v8_logo_sbereapteka.c86539ff.svg";